/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from "react";

import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import {
	Apresentation,
	ContentMain,
	DefaultButton,
	Error,
	MyTable,
	MyTableBody,
	MyTableHead,
	MyTableTR,
	Page,
	ScreenView,
	SubPageMain,
} from "../../style/default";
import { Skeleton } from "../../components/Skeleton/table";
import { MyHorizontalScrollView } from "./style";
import { toast } from "react-toastify";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import MyTooltip from "../../components/Tooltip";
import Select from "react-select";
import { customStyles } from "../../style/selectStyles";
import { SectorContext } from "../../context/sectorFilter";
import { FaCheck } from "react-icons/fa";
import { FiUserCheck } from "react-icons/fi";
import { AiOutlineUserDelete } from "react-icons/ai";

function Managers() {
	const [tableData, setTableData] = useState();
	const [selectAccountFilterData, setSelectAccountFilterData] = useState([{}]);
	const [selectedAccountFilterData, setSelectedAccountFilterData] = useState([
		{},
	]);
	const [isLoading, setIsLoading] = useState(false);
	const { client } = useContext(SectorContext);

	const populateTable = async (company = "") => {
		if (!company) {
			toast.warn(
				"Escolha uma conta para filtrar os gestores.",
				TOASTIFY_OPTIONS,
			);
		}

		try {
			setIsLoading(true);
			const { data } = await authApi.post("/managers/list", {
				accountId: company,
			});
			setIsLoading(false);
			setTableData(data);
		} catch (error) {
			setIsLoading(false);
			toast.error(
				"Escolha uma conta para filtrar os gestores",
				TOASTIFY_OPTIONS,
			);
		}
	};

	const populateSelect = async () => {
		try {
			const { data } = await authApi.get("/account/all/select");
			const seriData = [];
			data.forEach((item) => {
				seriData.push({ label: item.name, value: item._id });
			});
			setSelectAccountFilterData(seriData);
		} catch (error) {
			toast.error(
				"Não foi possivel encontrar os dados para filtro",
				TOASTIFY_OPTIONS,
			);
		}
	};

	useEffect(() => {
		populateSelect();
		setSelectedAccountFilterData(client ? client : undefined);
		populateTable(client?.value ? client?.value : "");
	}, []);

	async function handleOperatorAction({ item, action }) {
		const actions = {
			async disable(operator) {
				await authApi.post(`/managers/disable/${operator._id}`);
			},
			async active(operator) {
				await authApi.post(`/managers/active/${operator._id}`);
			},
			async sendPassword(operator) {
				await authApi.post(`/managers/redo-password/${operator._id}`);
			},
		};

		const confirmAction = window.confirm("Deseja realizar está ação?");

		if (!confirmAction) return;

		await actions[action](item);
		populateTable(selectedAccountFilterData.value);
	}

	return (
		<Page>
			<Sidebar activeMenu="managers" />
			<ScreenView>
				<ContentMain>
					<SubPageMain>
						<Apresentation>
							<span>Gestores</span>
						</Apresentation>
						{isLoading ? (
							<Skeleton
								data={[
									"Cliente",
									"Nome",
									"Email",
									"Ativo",
									"Admin",
									"É API",
									"Ações",
								]}
							/>
						) : (
							<>
								<MyHorizontalScrollView>
									<div>
										<Select
											styles={customStyles}
											placeholder={"Filtrar por cliente"}
											options={[
												{ label: "Todos", value: "" },
												...selectAccountFilterData,
											]}
											onChange={(e) => {
												setSelectedAccountFilterData(e);
												populateTable(e.value);
											}}
											value={selectedAccountFilterData}
											noOptionsMessage={"Nenhum dado encontrado!"}
										/>
									</div>
								</MyHorizontalScrollView>

								{tableData && tableData.length ? (
									<>
										<MyTable responsive>
											<MyTableHead>
												<MyTableTR>
													<th>Cliente</th>
													<th>Nome</th>
													<th>Email</th>
													<th>Ativo</th>
													<th>Admin</th>
													<th>É API</th>
													<th>Ações</th>
												</MyTableTR>
											</MyTableHead>
											<MyTableBody>
												{tableData?.map((item) => (
													<MyTableTR key={item._id}>
														<td>{item.accountName ?? "-"}</td>
														<td>{item.name ?? "-"}</td>
														<td>{item.email ?? "-"}</td>
														<td>{item.active ? "Sim" : ("Não" ?? "-")}</td>
														<td>{item.admin ? "Sim" : ("Não" ?? "-")}</td>
														<td>{item.apiAccess ? "Sim" : ("Não" ?? "-")}</td>
														<td>
															<div
																style={{
																	display: "flex",
																	gap: "10px",
																	justifyContent: "center",
																}}
															>
																<MyTooltip label={`Desativar: ${item.name}`}>
																	<DefaultButton
																		onClick={() => {
																			handleOperatorAction({
																				item,
																				action: "disable",
																			});
																		}}
																	>
																		<AiOutlineUserDelete size={20} />
																	</DefaultButton>
																</MyTooltip>
																<MyTooltip label={`Reativar: ${item.name}`}>
																	<DefaultButton
																		onClick={() => {
																			handleOperatorAction({
																				item,
																				action: "active",
																			});
																		}}
																	>
																		<FiUserCheck size={20} />
																	</DefaultButton>
																</MyTooltip>
																<MyTooltip
																	label={`Reenviar senha para: ${item.name}`}
																>
																	<DefaultButton
																		onClick={() => {
																			handleOperatorAction({
																				item,
																				action: "sendPassword",
																			});
																		}}
																	>
																		<FaCheck size={20} />
																	</DefaultButton>
																</MyTooltip>
															</div>
														</td>
													</MyTableTR>
												))}
											</MyTableBody>
										</MyTable>
									</>
								) : (
									<Error>Nenhum dado encontrado</Error>
								)}
							</>
						)}
					</SubPageMain>
				</ContentMain>
				<Footer />
			</ScreenView>
		</Page>
	);
}

export default Managers;
